import { Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import treydIcon from '@treyd-io/treyd-ui/assets/img/treyd_square_logo_black.svg';
import CloseIcon from '@treyd-io/treyd-ui/icons/CloseIcon';
import Image from 'next/image';
import { ReactNode } from 'react';
import { ResponsiveButton } from '../ResponsiveButton';

export interface TopBarProps {
  children?: ReactNode;
  barActions?: ReactNode;
  activeStep?: number;
  onClose?: () => void;
}

export const TopBar = (props: TopBarProps) => {
  const { onClose, barActions, children } = props;
  const theme = useTheme();
  const isSmallScreens = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Box
      paddingY={2}
      paddingX={isSmallScreens ? 2 : 3}
      top={0}
      height={80}
      zIndex={2}
      bgcolor="background.default"
      borderColor="other.divider"
      flexShrink={0}>
      <Box width="100%" height="100%" position="relative">
        <Box flexShrink={0} position="absolute" top={12} left={0}>
          <Image src={treydIcon} alt="Treyd" width="24" height="24" />
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%"
          width="100%"
          paddingX={6}>
          {children}
        </Box>
        <Box flexShrink={0} position="absolute" top={0} right={0}>
          {barActions}
          {onClose && (
            <ResponsiveButton
              onClick={onClose}
              variant="outlined"
              color="secondary"
              size="medium"
              iconButtonProps={{
                children: <CloseIcon />,
              }}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};
